export default __webpack_public_path__ + "static/media/fbicon.88c4ba71.svg";